import { useEffect, useState } from "react";
import { animate, useMotionValue } from "framer-motion";
import { fmtAUD } from "@/lib/tax";

export default function Money({ value, className = "", testId }) {
    const mv = useMotionValue(0);
    const [display, setDisplay] = useState(fmtAUD(0));

    useEffect(() => {
        const controls = animate(mv, value, {
            duration: 0.55,
            ease: [0.16, 1, 0.3, 1],
            onUpdate: (v) => setDisplay(fmtAUD(v)),
        });
        return () => controls.stop();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return (
        <span data-testid={testId} className={className}>
            {display}
        </span>
    );
}
